import PersonalAccessTokens from './PersonalAccessTokens';
import reducer from './PersonalAccessTokensReducer';

export const reducers = { personalAccessTokens: reducer };

export default PersonalAccessTokens;



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/users/PersonalAccessTokens/index.js